/*
  import { chargeTypeStore } from '@/services/ChargeType/store'
*/

import Vue from 'vue'
import Vuex from 'vuex'
import { notifyProblem } from '@/services/notify'
import kms from '@/services/kms'

const isDebug = true

/* eslint-disable no-empty-pattern */
const actions = {
  /*
    const { list } = await chargeTypeStore.dispatch ('getChargeTypeScheduleEligibleList', {
      ownerID,
      isEligible
    });
  */
  async getChargeTypeScheduleEligibleList({}, { hoaID, isEligible }) {
    console.log('in getChargeTypeScheduleEligibleList...')
    try {
      const result = await kms.get('/AccountsReceivable/ChargeType/List', {
        params: {
          hoaID,
          scheduledPaymentEligible: isEligible
        }
      })

      if (isDebug == true)
        console.debug('getChargeTypeScheduleEligibleList log=' + JSON.stringify(result))

      return {
        list: result.results
      }
    } catch (exception) {
      notifyProblem(`The charge type Scheduled Payment Eligible list could not be retrieved.`)
      console.error(exception)
    }

    return {
      list: []
    }
  }
}
/* eslint-enable no-empty-pattern */

Vue.use(Vuex)
export const chargeTypeStore = new Vuex.Store({
  state: {},
  mutations: {},
  getters: {},
  actions
})
